export default "__VITE_ASSET__Bdx6Vh4M__"